// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"d490ba87","498":"e0a1a6c2","513":"77548a7f","703":"0599608b"}[chunkId] + ".chunk.js";
};